<!--***************************************
CREATED BY : Vekanth
Last Modified Date : 26/06/2018
**************************************/-->

<div class="container-fluid">
  @if (searchCriteria) {
    <div class="row refine-search">
      <div class="col-md-9 search-for">
        @if (searchCriteria?.providerId || searchCriteria?.name || searchCriteria?.speciality || searchCriteria?.ipa || searchCriteria?.zipCodeAndCity || searchCriteria?.distance || searchCriteria?.neighborhood) {
          <span class="searched-for">Searched For : </span>
        }
        @if (searchCriteria?.providerId) {
          <span class="searched-for-details">Provider ID - {{searchCriteria?.providerId}}</span>
        }
        @if (searchCriteria?.name) {
          <span class="searched-for-details">Name - {{searchCriteria?.name}}</span>
        }
        @if (searchCriteria?.speciality) {
          <span class="searched-for-details">Speciality - {{searchCriteria?.speciality?.value}}</span>
        }
        @if (searchCriteria?.ipa) {
          <span class="searched-for-details">IPA - {{searchCriteria?.ipa?.value}}</span>
        }
        @if (searchCriteria?.zipCodeAndCity) {
          <span class="searched-for-details">ZipCode - {{searchCriteria?.zipCodeAndCity}}</span>
        }
        @if (searchCriteria?.distance) {
          <span class="searched-for-details">Distance - {{searchCriteria?.distance}}</span>
        }
        @if (searchCriteria?.neighborhood) {
          <span class="searched-for-details">Neighborhood - {{searchCriteria?.neighborhood?.value}}</span>
        }
        <!-- <button class="btn btn-primary rounded-btn" *ngIf="loadGridWithResults" (click)="refineSearch()">Refine Search</button>
        <button class="btn btn-secondary rounded-btn" *ngIf="loadGridWithResults" (click)="clearSearch()">Clear All</button> -->
        <!-- <button class="btn btn-primary rounded-btn" (click)="refineSearch()">Refine Search</button> -->
        <!-- <button class="btn btn-secondary rounded-btn" (click)="clearAll()" *ngIf="searchCriteria">Clear All</button> -->
      </div>
      <div class="col-md-1">
        @if (searchCriteria?.providerId || searchCriteria?.name || searchCriteria?.speciality || searchCriteria?.ipa
          || searchCriteria?.zipCodeAndCity || searchCriteria?.distance || searchCriteria?.neighborhood) {
          <button class="btn btn-secondary rounded-btn reset-default" (click)="clearAll()">Reset to Default
            <span>
              <i class="fa fa-times" aria-hidden="true"></i>
            </span>
          </button>
        }
      </div>
    </div>
  }
  <!--Grid-->
  <div class="row">
    <!-- <div class="col-md-16 fluid-pagination-width cup-pager-width master-provider-search-grid in-auth-screens">
    <cup-grid #providerSearchGrid [gridRows]="gridRows" [gridColumns]="providerSearchGridColumns" (eventOutput)="eventOutput($event)"  [showViewHeader]="showView"
      [showMapViewHeader]="showMapViewHeader"  (mapOutput)=  "mapOutput($event)" [currentPath]="currentPath" [totalRecords]="totalRecords"
      [isLazyLoad]="isServerSidePagination"  (onPageChanged)="onPageChanged($event)"  [pageFromParent]=  "pages" [gridTitle]="providerSearchGridTitle"
    [showProvider]="showProvider" [masterProviderGrid]="'true'" [nwstatus]='nwstatus' [showProviderMap]="showProviderMap" [gridStatusText]="providerGridStatusText"></cup-grid>
  </div> -->
</div>
@if (messageFromOverAllSearch) {
  <div class="row">
    <div class="col-md-16 no-records">
      <span>No provider records match the search criteria</span>
    </div>
  </div>
}

<!--Over All Search Pop up -->
<div>
  <button id="overAllSearchModal" hidden data-toggle="modal" data-target="#overallsearch">Open Modal</button>
  <div class="modal fade" id="overallsearch" role="dialog">
    <div class="modal-dialog modal-md modalContainer">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header modalCss">
          <a class="" href="javascript:void(0);">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </a>
          <label>ALERT!</label>
          <button id="closeBtn" type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body bodyModalCSS">
          <div class="col-md-16">
            <div class="disclaimerEligblity"> No provider records match the search criteria
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Over All Search Pop up -->
<!-- <div class="row">
<cup-grid [gridRows]="gridRows" [gridColumns]="providerSearchGridColumns" (eventOutput)="eventOutput($event)" [showViewHeader]="showView"
  [showMapViewHeader]="showMapViewHeader" (mapOutput)="mapOutput($event)" [currentPath]="currentPath" [totalRecords]="totalRecords"
[isLazyLoad]="isServerSidePagination" (onPageChanged)="onPageChanged($event)" [pageFromParent]="pages" [gridTitle]="providerSearchGridTitle"></cup-grid>
</div> -->
</div>